import React from 'react';

import { isBrowser } from '@backyard-ui/utils';

const useEnhancedEffect = isBrowser ? React.useLayoutEffect : React.useEffect;

export default useEnhancedEffect;
